import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleRouteGuard {
  constructor(private router: Router) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    const isFeatureDisabled: boolean = next.data['disabled'] ?? false;
    if (!isFeatureDisabled) {
      return true;
    }

    await this.router.navigate(['/']);
    return false;
  }
}
